import { GlobalToken } from "antd";
import styled from "styled-components";

export const StyledVerticalPanelResizeHandle = styled.div<{
  theme: GlobalToken;
}>`
  width: 1px;
  height: 100%;
  background: ${({ theme }) => theme.colorBorder};
  margin-left: 1px;
  margin-right: 1px;
`;

export const StyledHorizontalPanelResizeHandle = styled.div<{
  theme: GlobalToken;
  $backgroundColor?: string;
  $opacity?: number;
  handleHeight?: number;
  $hoverAreaHeight?: number;
  $margin?: number;
}>`
  width: 100%;
  height: ${({ handleHeight }) => handleHeight ?? 1}px;
  background: ${({ $backgroundColor, theme }) =>
    $backgroundColor ?? theme.colorBorder};
  margin-top: ${({ $margin }) => $margin ?? 1}px;
  margin-bottom: ${({ $margin }) => $margin ?? 1}px;
  opacity: ${({ $opacity }) => $opacity ?? 1};
  position: relative;
  &:hover {
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
  }
  &::before {
    content: "";
    position: absolute;
    top: -${({ $hoverAreaHeight, handleHeight }) =>
        $hoverAreaHeight ?? 0 / 2 - (handleHeight ?? 1)}px;
    left: 0;
    right: 0;
    height: ${({ $hoverAreaHeight, handleHeight }) =>
      $hoverAreaHeight ?? 0 + (handleHeight ?? 1)}px;
    cursor: row-resize;
    z-index: 1;
  }
`;
